import { Component, OnInit, AfterViewInit } from "@angular/core";
import { ReportService } from "../report.service";
//Import Custom Services Here
import { SchoolService } from "../../../shared/services/school.service";
import { SemesterService } from "../report-services/semester.service";
import { PeriodService } from "../report-services/period.service";
import { MstrDateService } from "../report-services/m-str-date.service";
import { InstructorService } from "../report-services/instructor.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { DialogService } from "primeng/dynamicdialog";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import * as moment from "moment";

@Component({
	templateUrl: "./teacherattendanceverification.component.html",
})
export class TeacherAttendanceVerificationComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private instructorService: InstructorService,
		private mstrdateService: MstrDateService,
		private periodService: PeriodService,
		private semesterService: SemesterService,
		private schoolService: SchoolService,
		private dialogService: DialogService
	) {}
	report = {
		//Insert Custom Parameters Here
		SchoolID: 0,
		SemesterID: 0,
		PeriodID: 0,
		MstrDateID: 0,
		InstructorID: 0,
		MPDateStart: new Date(),
		MPDateEnd: new Date(),
		ORDERBYID: "Course Number",
		ImageLogo: "",
	};

	//Insert Custom Lists Here
	schoolList: any = [];
	SemesterList: any = [];
	PeriodList: any = [];
	MstrDateList: any = [];
	InstructorList: any = [];
	ImageLogoList: any = [];

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	ORDERBYList = [
		//Insert Custom List Items Here
		{
			ORDERBYID: "Course Number",
			ORDERBYName: "Course Number",
		},
		{
			ORDERBYID: "Course Name",
			ORDERBYName: "Course Name",
		},
		{
			ORDERBYID: "Instructor",
			ORDERBYName: "Instructor",
		},
		{
			ORDERBYID: "Room Number",
			ORDERBYName: "Room Number",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 223;

	subscription: any;

	ngOnInit() {
		//Insert Custom Init Methods Here
		// this.loadSchoolist()
		// this.loadSemesterList()
		// this.loadPeriodList()
		// this.loadMstrDateList()
		// this.loadInstructorList()

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadSemesterList();
		this.loadPeriodList();
		this.loadMstrDateList();
		this.loadInstructorList();
		this.loadLogolist();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(223);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	private loadSemesterList() {
		this.report.SemesterID = 0;
		var result = this.semesterService.loadSemesterList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.SemesterList = response;

				if (this.SemesterList.length > 1) {
					// this.SemesterList.unshift({
					//     SemesterID: 0,
					//     Semester: "All Semesters"
					// })
					this.report.SemesterID = this.SemesterList[0].SemesterID;
				} else {
					this.report.SemesterID = this.SemesterList[0].SemesterID;
				}
			},
			(error) => {}
		);
	}

	private loadPeriodList() {
		this.report.PeriodID = 0;
		var result = this.periodService.loadPeriodList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.PeriodList = response;

				if (this.PeriodList.length > 1) {
					this.PeriodList.unshift({
						PeriodID: 0,
						PeriodDesc: "All Periods",
					});
					this.report.PeriodID = this.PeriodList[0].PeriodID;
				} else {
					this.report.PeriodID = this.PeriodList[0].PeriodID;
				}
			},
			(error) => {}
		);
	}

	private loadMstrDateList() {
		this.report.MstrDateID = 0;
		var result = this.mstrdateService.loadMstrDateList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.MstrDateList = response;

				if (this.MstrDateList.length > 1) {
					// this.MstrDateList.unshift({
					//     MonthDate: 0,
					//     MonthDesc: "All Months"
					// })
					this.report.MstrDateID = this.MstrDateList[0].MonthDate;
				} else {
					this.report.MstrDateID = this.MstrDateList[0].MonthDate;
				}
			},
			(error) => {}
		);
	}

	private loadInstructorList() {
		this.report.InstructorID = 0;
		var result = this.instructorService.loadInstructorList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.InstructorList = response;

				if (this.InstructorList.length > 1) {
					// this.InstructorList.unshift({
					//     Teacher_PersonID: 0,
					//     Instructor: "All Instructors"
					// })
					this.report.InstructorID = this.InstructorList[0].Teacher_PersonID;
				} else {
					this.report.InstructorID = this.InstructorList[0].Teacher_PersonID;
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		// if (!this.report.SemesterID) {
		// 	this.errorMessage = "Select the Semester"
		// 	return;
		// }

		// if (!this.report.PeriodID) {
		// 	this.errorMessage = "Select the Period"
		// 	return;
		// }

		// if (!this.report.MstrDateID) {
		// 	this.errorMessage = "Select the MstrDate"
		// 	return;
		// }

		// if (!this.report.InstructorID) {
		// 	this.errorMessage = "Select the Instructor"
		// 	return;
		// }

		// if (!this.report.MPDateStart) {
		// 	this.errorMessage = "Select the MPDateStart"
		// 	return;
		// }

		// if (!this.report.MPDateEnd) {
		// 	this.errorMessage = "Select the MPDateEnd"
		// 	return;
		// }

		// if (!this.report.ORDERBYID) {
		// 	this.errorMessage = "Select the ORDERBY"
		// 	return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 223;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: SchoolID
		strParam += this.report.SchoolID + "|SchoolID";

		//Parameter 2: SemesterID
		strParam += "," + this.report.SemesterID + "|SemesterID";

		//Parameter 3: PeriodID
		strParam += "," + this.report.PeriodID + "|PeriodID";

		//Parameter 4: MstrDate
		strParam += "," + this.report.MstrDateID + "|MstrDate";

		//Parameter 5: InstructorID
		strParam += "," + this.report.InstructorID + "|InstructorID";

		//Parameter 6: MPDateStart
		strParam += "," + moment(this.report.MPDateStart).format("MM/DD/YYYY") + "|MPDateStart";

		//Parameter 7: MPDateEnd
		strParam += "," + moment(this.report.MPDateEnd).format("MM/DD/YYYY") + "|MPDateEnd";

		//Parameter 8: ORDERBY
		strParam += "," + this.report.ORDERBYID + "|ORDERBY";

		//Parameter 9: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
